function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.85,
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36 63C52.5685 63 66 49.5685 66 33C66 16.4315 52.5685 3 36 3C19.4315 3 6 16.4315 6 33C6 49.5685 19.4315 63 36 63Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.9991 14.1233L35.8703 13.2375L34.7805 14.1709C31.7771 16.7429 30.0454 19.336 29.3321 21.8599C25.816 20.9788 22.0796 21.654 19.6619 22.5167L18.2067 23.0359L18.5416 24.5442C19.3816 28.3272 20.8741 31.0423 22.7823 32.8744C20.8741 34.7066 19.3816 37.4217 18.5416 41.2046L18.2067 42.713L19.6619 43.2322C22.0796 44.0949 25.816 44.7701 29.3321 43.889C30.0454 46.4129 31.7771 49.006 34.7805 51.578L35.8703 52.5113L36.9991 51.6256C38.996 50.0586 41.5307 47.2676 42.4951 43.8445C46.0632 44.7929 49.885 44.1075 52.3381 43.2322L53.7933 42.713L53.4583 41.2046C52.6183 37.4217 51.1258 34.7066 49.2177 32.8745C51.1258 31.0423 52.6183 28.3272 53.4583 24.5442L53.7933 23.0359L52.3381 22.5167C49.885 21.6414 46.0632 20.956 42.4951 21.9044C41.5307 18.4813 38.996 15.6903 36.9991 14.1233ZM32.454 24.282C32.5434 22.5422 33.3954 20.3513 35.9444 17.8474C37.6698 19.5301 39.25 21.9143 39.3826 24.3654L39.5258 27.0132L41.9041 25.8404C44.2405 24.6882 47.2229 24.7914 49.6271 25.3615C48.6147 28.6473 47.0424 30.4273 45.4582 31.371L42.9342 32.8744L45.4582 34.3779C47.0424 35.3216 48.6147 37.1016 49.6271 40.3874C47.2229 40.9575 44.2405 41.0607 41.904 39.9085L39.5258 38.7357L39.3826 41.3835C39.25 43.8346 37.6698 46.2188 35.9444 47.9014C33.3954 45.3976 32.5434 43.2067 32.454 41.4669L32.3205 38.8678L29.9639 39.972C27.6467 41.0576 24.7295 40.9461 22.3729 40.3873C23.3853 37.1016 24.9575 35.3216 26.5417 34.3779L29.0657 32.8744L26.5417 31.371C24.9575 30.4273 23.3853 28.6473 22.3729 25.3615C24.7295 24.8028 27.6467 24.6913 29.9639 25.7769L32.3205 26.881L32.454 24.282ZM36 36.5C37.933 36.5 39.5 34.933 39.5 33C39.5 31.067 37.933 29.5 36 29.5C34.067 29.5 32.5 31.067 32.5 33C32.5 34.933 34.067 36.5 36 36.5Z",
  fill: "#89744C"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgDecorTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorTool);
export default __webpack_public_path__ + "static/media/decor-tool.3df12de4.svg";
export { ForwardRef as ReactComponent };